import React from "react"
import styled from "styled-components"

interface ButtonProps {
  text: string
  icon?: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  type?: "button" | "submit" | "reset"
  className?: string
  variant?: "default" | "rounded"
}

const StyledButton = styled.button<{ variant?: "default" | "rounded" }>`
  font: inherit;
  color: var(--white);
  max-width: 16rem;
  width: 100%;
  padding: 0.8rem 2rem;
  border-radius: ${(props) =>
    props.variant === "rounded" ? "2rem" : "0.5rem"};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  border: none;
  background: linear-gradient(
    135deg,
    var(--primary) 0%,
    var(--secondary) 50%,
    var(--special) 100%
  );

  font-weight: bold;
  font-size: 1.1rem;
  font-family: "Filson Soft", Arial, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  cursor: pointer;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15), 0 0 0 2px transparent;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25),
      0 0 0 3px var(--special-transparent);
    filter: brightness(1.1);
  }

  &:focus {
    outline: 3px solid var(--special);
    outline-offset: 4px;
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      transform: none;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15), 0 0 0 2px transparent;
      filter: none;
    }
  }
`

const Button: React.FC<ButtonProps> = ({
  text,
  icon,
  onClick,
  disabled = false,
  type = "button",
  className,
  variant = "default",
}) => {
  return (
    <StyledButton
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      variant={variant}>
      {icon && icon}
      {text}
    </StyledButton>
  )
}

export default Button
